import React from 'react';
import PropTypes from 'prop-types';

import {
    Checkbox,
    LabeledControl,
    Switch,
} from '@zillow/constellation';

import {
    StyledDiv,
    StyledText,
} from './StyledComponents';

const propTypes = {
    // eslint-disable-next-line react/require-default-props
    className: PropTypes.string,
    disabled: PropTypes.bool.isRequired,
    on: PropTypes.bool.isRequired,
    onClick: PropTypes.func.isRequired,
};

const OnOffSwitch = React.forwardRef(({
    className,
    disabled,
    on,
    onClick,
}, ref) => {
    const displayText = on ? 'Enabled' : 'Off';

    return (
        <StyledDiv className={className}>
            <LabeledControl
                controlId="LabeledControlSwitchOnOff"
                control={(
                    <Switch
                        checkbox={(
                            <Checkbox
                                ref={ref}
                                checked={on}
                                aria-label="Enable or Off switch"
                            />
                        )}
                    />
                )}
                size="lg"
                disabled={disabled}
                onClick={onClick}
            />
            <StyledText
                marginLeft="xs"
                on={on}
                as="div"
            >
                {displayText}
            </StyledText>
        </StyledDiv>
    );
});

OnOffSwitch.propTypes = propTypes;

export default OnOffSwitch;
